<template>
    <Menu as="div" class="fixed context-menu" :style="menuPosition">
        <div class="min-w-[200px] overflow-hidden rounded-md border bg-white shadow-md">
            <div class="py-1">
                <!-- Trend Alert -->
                <MenuItem v-slot="{ active }" v-if="!isBulkAction && isActive">
                <a :class="[
                    'flex items-center px-4 py-2 text-sm cursor-pointer',
                    active ? 'bg-gray-100' : ''
                ]" @click="$emit('set-trend-alert', isParentRow ? 'Event' : 'Market')">
                    <i class="fas fa-bell mr-2"></i>
                    Create {{ isParentRow ? 'Event' : 'Market' }} Alert
                </a>
                </MenuItem>

                <!-- Add to Watchlist with submenu -->
                <!-- <MenuItem v-slot="{ active }" as="div" v-if="store.currentWatchListId && store.isAuthenticated">  -->
                    <MenuItem v-slot="{ active }" as="div" v-if="false"> 

               
                    <!-- Submenu with pagination -->
                    <Float show :z-index="20" :flip="true" placement="right-start" as="div">
                        <div
                            @mouseenter="showSubmenu = true"
                            @mouseleave="showSubmenu = false">
                            <a :class="[
                                ' flex items-center justify-between px-4 py-2 text-sm cursor-pointer w-full',
                                showSubmenu ? 'bg-gray-100' : '' // 
                            ]">
                                <div class="flex items-center">
                                    <i class="fas fa-plus mr-2"></i>
                                    Add to Watchlist
                                </div>
                                <i class="fas fa-chevron-right ml-2"></i>
                            </a>
                        </div>

                        <div 
                            :class="[
                                'min-w-[160px] bg-white rounded-md shadow-lg border border-gray-200',
                                shouldShowSubmenu ? 'visible' : 'invisible'
                            ]"
                            @mouseenter="keepSubmenuOpen" 
                            @mouseleave="hideSubmenu">
                            <div class="py-1" @click.stop>
                                <!-- $emit('create-new-table', this.$refs.newWatchlistNameInput.value.trim())-->
                                <div class="flex items-center justify-between">
                                    <input type="text" placeholder="+ New Watchlist" ref="newWatchlistNameInput"
                                        class="w-10/12 pl-4 py-2 border-b text-sm text-gray-700 hover:bg-gray-100 focus:outline-none" maxlength="40"
                                        v-model="newWatchlistName" @keyup.enter="createNewWatchlist()" @click.stop
                                        :disabled="isCreatingNewWatchlist"
                                        />
                                        
                                        <button class="hover:text-gray-700 disabled:opacity-50 border border-gray-200 rounded-md px-2 py-1 h-full"
                                        :disabled="isCreateNewWatchlistDisabled()"
                                        @click="createNewWatchlist()">
                                        <i v-if="!isCreatingNewWatchlist" class="fas fa-plus text-xs"></i>
                                        <i v-else class="fas fa-spinner fa-spin text-xs"></i>
                                        </button>
                                </div>
                                <a v-for="list in paginatedWatchLists" :key="list.id"
                                    class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                                    @click="$emit('add-to-table', list.id)">
                                    {{ list.name }}
                                </a>
                                <div class="flex justify-between text-gray-500 items-center px-2 py-1 border-t"
                                    v-if="watchLists.length > itemsPerPage">
                                    <button class="hover:text-gray-700 disabled:opacity-50 border border-gray-200 rounded-md px-2 py-1"
                                        :disabled="currentPage === 0"
                                        @click.stop.prevent="handlePaginationClick('prev')">
                                        <i class="fas fa-chevron-left text-xs"></i>
                                    </button>
                                    <span class="text-xs">
                                        {{ currentPage + 1 }}/{{ totalPages }}
                                    </span>
                                    <button class="hover:text-gray-700 disabled:opacity-50 border border-gray-200 rounded-md px-2 py-1"
                                        :disabled="currentPage >= totalPages - 1"
                                        @click.stop.prevent="handlePaginationClick('next')">
                                        <i class="fas fa-chevron-right text-xs"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Float>
                
                </MenuItem>

                <MenuItem v-if="shouldShowAddAllMarkets" v-slot="{ active }">
                <a :class="[
                    'flex items-center px-4 py-2 text-sm cursor-pointer',
                    active ? 'bg-gray-100' : ''
                ]" 
                    @click="$emit('add-all-markets')"
                    v-tippy="{content: 'New markets associated with this event will be added automatically only if they match the watchlist query.<p class=\'mt-2\'>Click to track all markets instead.</p>', allowHTML: true}">
                    <i class="fas fa-circle-check mr-2"></i>
                    Track All Markets
                </a>
                </MenuItem>

                <!-- Remove from List -->
                <MenuItem v-if="isWatchList" v-slot="{ active }" >
                <a :class="[
                    'flex items-center px-4 py-2 text-sm cursor-pointer text-red-600',
                    active ? 'bg-gray-100' : ''
                ]" @click="$emit('remove-from-list')">
                    <i class="far fa-trash-alt mr-2"></i>
                    Remove from List
                </a>
                </MenuItem>
            </div>
        </div>
    </Menu>
</template>

<script>
import { Menu, MenuItem } from '@headlessui/vue'
import { Float } from '@headlessui-float/vue'
import { store } from '../../store'

export default {
    components: {
        Menu,
        MenuItem,
        Float
    },
    props: {
        position: {
            type: Object,
            default: () => ({ x: 0, y: 0 })
        },
        isBulkAction: Boolean,
        watchLists: {
            type: Array,
            default: () => []
        },
        currentWatchList: {
            type: Object,
            default: () => {}
        },
        isParentRow: Boolean,
        shouldShowAddAllMarkets: Boolean,
        isWatchList: Boolean,
        isActive: Boolean
    },
    data() {
        return {
            store,
            newWatchlistName: '',
            showSubmenu: false,
            currentPage: 0,
            itemsPerPage: 5,
            submenuTimer: null,
            isPaginating: false,
            isCreatingNewWatchlist: false
        }
    },
    computed: {
        shouldShowSubmenu() {
            return this.showSubmenu
        },
        menuPosition() {
            return {
                left: `${this.position.x}px`,
                top: `${this.position.y}px`
            }
        },
        totalPages() {
            return Math.ceil(this.watchLists.length / this.itemsPerPage)
        },
        paginatedWatchLists() {
            const start = this.currentPage * this.itemsPerPage
            const filteredWatchLists = this.watchLists.filter(list => list.id !== this.currentWatchList?.id)
            return filteredWatchLists.slice(start, start + this.itemsPerPage)
        }
    },

    methods: {
        hideSubmenu() {
            if (!this.isPaginating && !this.isCreatingNewWatchlist) {
                this.showSubmenu = false
                this.currentPage = 0
                this.newWatchlistName = ''
            }
        },
        keepSubmenuOpen() {
            this.showSubmenu = true
            if (this.submenuTimer) {
                clearTimeout(this.submenuTimer)
            }
        },
        handlePaginationClick(direction) {
            this.isPaginating = true
            if (direction === 'prev') {
                this.currentPage = Math.max(0, this.currentPage - 1)
            } else {
                this.currentPage = Math.min(this.totalPages - 1, this.currentPage + 1)
            }
            setTimeout(() => {
                this.isPaginating = false
            }, 100)
        },
        async createNewWatchlist() {
            const name = this.newWatchlistName.trim()
            if (name.length === 0) {
                return
            }
            this.isCreatingNewWatchlist = true
            this.$refs.newWatchlistNameInput.blur()

            this.$emit('create-new-table', name) 
            
            // Simulate API call
            // await new Promise(resolve => setTimeout(resolve, 2000)); 

            // console.log('finished creating watchlist (simulated)');
            // this.isCreatingNewWatchlist = false;
            // this.newWatchlistName = ''; // Clear input on success
            // Maybe close the submenu here? Or let the user decide.
        },
        isCreateNewWatchlistDisabled() {
            return this.isCreatingNewWatchlist || this.newWatchlistName.trim().length === 0
        }
    },
    emits: [
        'set-trend-alert',
        'add-to-table',
        'create-new-table',
        'remove-from-list',
        'open-in-new-tab',
        'copy-event-link',
        'add-all-markets'
    ]
}
</script>

<style scoped>
.context-menu {
    z-index: 30;
}
</style>